import React from 'react';
import './campaign.css';
import useCampaignReveal from './useCampaignReveal';

const CampaignPageLayout = ({ children }) => {
  useCampaignReveal();

  return <div className="hhc-campaign-page">{children}</div>;
};

export default CampaignPageLayout;
